import useSWR, { invalidateStartsWith } from 'hooks/useSWR';
import { CompanyConversation, conversationApiUrls } from 'apis/CompanyAPI/conversations/conversationApi';
import { PaginatedResult, PaginationOptions } from 'types/api';
import { useSWRResource } from 'util/resource/useSWRResource';
import { notEmpty } from 'util/arrayUtils';
import { useUserProfiles } from 'apis/CompanyAPI/users/useUserProfiles';

export const reloadCompanyInbox = (companyId: number) => {
  invalidateStartsWith([conversationApiUrls.company.list(companyId)]);
};

export function useCompanyInbox(
  companyId: number | undefined,
  paginationOptions: PaginationOptions,
  canReadCompanyInbox: boolean,
) {
  const swrResult = useSWR<PaginatedResult<CompanyConversation>>(
    canReadCompanyInbox && companyId ? conversationApiUrls.company.list(companyId, paginationOptions) : undefined,
  );

  const swrResource = useSWRResource(swrResult);

  const creatorIds =
    swrResource.resource.state === 'fetched'
      ? swrResource.resource.resource.values.map(c => c.companyConversation?.cwUserId).filter(notEmpty)
      : [];
  useUserProfiles(creatorIds);

  return swrResource;
}
